'use client';

import type { ReactNode } from 'react';
import { FindingEditContentWrapper } from '../../HITL/wrappers/FindingEditContentWrapper';
import type { EditContentProps } from '../../tool-config-types';

export const renderFindingEditContent = (
  props: EditContentProps,
): ReactNode => (
  <FindingEditContentWrapper
    onClose={props.onClose}
    onSubmit={props.onSubmit}
    onApprove={props.onApprove}
    onReject={props.onReject}
    toolName={props.toolName}
    args={props.args}
    extractedData={props.extractedData}
    defaultCvssVersion={props.defaultCvssVersion}
  />
);
